import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import { PENDING_CERTS_QUERY_KEY } from "@/hooks/queries/useListPendingLegacyCerts";
import type { RejectedCertData } from "@/hooks/queries/admin-legacy-cert-types";

// POST /admin/legacy-certs/{id}/reject (Story 16.5, AC1/7) — super_admin rejects a
// pending cert with a required free-text reason (surfaced to the clinician on next
// sign-in). On success the pending-queue query is invalidated so the decided row
// leaves the queue (AC7). A post-session call, so it rides apiFetch's silent-refresh
// path (skipAuthRefresh omitted). Unlike approve, reject is wholly in-context: it
// emits NO domain event and does NOT touch the account (is_active / cert_verified).

interface RejectCertVars {
  certId: string;
  reason: string;
}

export function useRejectLegacyCert() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ certId, reason }: RejectCertVars) =>
      apiFetch<RejectedCertData>(`/admin/legacy-certs/${certId}/reject`, {
        method: "POST",
        // apiFetch JSON-stringifies a non-FormData body and sets Content-Type itself.
        body: { reason },
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: PENDING_CERTS_QUERY_KEY });
    },
  });
}
